export const BRANDING = {
	// Core branding
	appName: "pyBlaze",
	appNameParts: {
		prefix: "py",
		suffix: "Blaze",
	},
	tagline: "Interactive Python Learning Environment",
	shortTagline: "Python Learning Made Simple",

	// Brand colors
	colors: {
		brand: {
			prefix: "text-gray-600 dark:text-gray-300", // for "py"
			suffix: "text-orange-600 dark:text-orange-400", // for "Blaze"
			primary: "text-blue-600 dark:text-blue-400",
			secondary: "text-orange-600 dark:text-orange-400",
		},
		backgrounds: {
			primary: "bg-slate-500 hover:bg-slate-600",
			secondary: "bg-orange-500 hover:bg-orange-600",
			success: "bg-emerald-500 hover:bg-emerald-600",
			accent: "bg-slate-100 dark:bg-slate-800/40",
			orange: "bg-orange-50 dark:bg-orange-900/20",
			green: "bg-emerald-50 dark:bg-emerald-900/20",
			purple: "bg-purple-50 dark:bg-purple-900/20",
		},
		gradients: {
			primary:
				"bg-gradient-to-r from-slate-500 to-slate-600 hover:from-slate-600 hover:to-slate-700",
			secondary:
				"bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700",
			success:
				"bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700",
		},
		borders: {
			primary: "border-slate-200 dark:border-slate-600",
			orange: "border-orange-200 dark:border-orange-700",
			green: "border-emerald-200 dark:border-emerald-600",
			purple: "border-purple-200 dark:border-purple-700",
		},
		text: {
			primary: "text-slate-600 dark:text-slate-400",
			orange: "text-orange-600 dark:text-orange-400",
			green: "text-emerald-600 dark:text-emerald-400",
			purple: "text-purple-600 dark:text-purple-400",
		},
	},

	// Descriptions
	mainDescription:
		"Learn Python programming through interactive coding, step-by-step debugging, and hands-on examples designed for beginners.",
	shortDescription:
		"Interactive Python learning with visual debugging and guided examples",

	// Features
	features: {
		liveExecution: "Live Code Execution",
		stepByStep: "Step-by-Step Learning",
		visualDebugging: "Visual Debugging",
		guidedExamples: "Guided Examples",
		drawingAnnotations: "Drawing Annotations",
	},

	// Welcome messages
	welcome: {
		greeting: "Welcome to pyBlaze!",
		subtitle: "Ready to start your Python programming journey?",
		description:
			"pyBlaze makes learning Python fun and interactive with step-by-step guidance, visual debugging, and hands-on examples.",
		benefits: ["Interactive Learning", "Visual Debugging", "Guided Examples"],
	},

	// Help content
	help: {
		title: "Quick Help",
		sections: [
			{
				title: "How to run code",
				content:
					"Click the green Run Code button to execute your Python program",
			},
			{
				title: "Learn step-by-step",
				content:
					"Use the Learn Mode button to see how your code runs line by line",
			},
			{
				title: "Try examples",
				content:
					"Click Examples to see ready-made Python programs you can learn from",
			},
			{
				title: "Need help with Python?",
				content:
					"Python uses indentation (spaces) to organize code. Always line up your code properly!",
			},
		],
	},

	// Footer
	footer: {
		copyright: "© 2025 pyBlaze. Interactive Python Learning Environment.",
		description:
			"Learn Python programming through interactive examples and visual debugging",
	},

	// Button labels
	buttons: {
		examples: "Examples",
		runCode: "Run Code",
		learnMode: "Learn Mode",
		getStarted: "Start Coding!",
		showTutorial: "Show Tutorial",
		viewExamples: "View Examples",
	},

	// Status messages
	status: {
		ready: "Ready",
		loading: "Loading",
		learning: "Learning",
		error: "Error",
		finished: "Finished",
	},
} as const;
